// Module
var code = "<template>\n  <require from=\"../../../../features/mooring/mooring-criteria-for-validity-container\"></require>\n  <mooring-criteria-for-validity-container></mooring-criteria-for-validity-container>\n</template>\n";
// Exports
export default code;